import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import AdminSidebar from "../../../component/AdminComp/AdminSidebar";
import AdminTopbar from "../../../component/AdminComp/AdminTopbar";
import { baseurl, imageUrl } from "../../../Baseurl";
import Swal from "sweetalert2";

const EditMenu = () => {
  const [menus, setMenus] = useState([]); // Menu list for dropdown
  const [title, setTitle] = useState(""); // Menu title
  const [parentId, setParentId] = useState(null); // Parent menu ID
  const [position, setPosition] = useState(0); // Position in menu
  const [isCategory, setIsCategory] = useState(false); // Is category checkbox
  const [image, setImage] = useState(null); // New image file
  const [currentImage, setCurrentImage] = useState(""); // Current menu image
  const [loading, setLoading] = useState(true); // Loader state
  const { id } = useParams();
  const navigate = useNavigate();

  // Fetch Menus for Dropdown
  useEffect(() => {
    axios
      .get(`${baseurl}getMenus`)
      .then((response) => {
        setMenus(buildMenuHierarchy(response.data));
      })
      .catch((error) => console.error("Error fetching menus:", error));
  }, []);

  // Fetch Menu Details by ID
  useEffect(() => {
    if (id) {
      axios
        .get(`${baseurl}getMenuById/${id}`)
        .then((response) => {
          const menu = response.data;
          setTitle(menu.title);
          setParentId(menu.parent_id);
          setPosition(menu.position);
          setIsCategory(menu.is_category);
          setCurrentImage(menu.image); // Set current image URL
          setLoading(false);
        })
        .catch((error) => console.error("Error fetching menu:", error));
    }
  }, [id]);

  // Recursive function to build menu hierarchy
  const buildMenuHierarchy = (menus, parentId = null, prefix = "") => {
    let result = [];
    menus
      .filter((menu) => menu.parent_id === parentId)
      .forEach((menu) => {
        const fullPath = prefix ? `${prefix} > ${menu.title}` : menu.title;
        result.push({ ...menu, fullTitle: fullPath });
        result = result.concat(buildMenuHierarchy(menus, menu.id, fullPath));
      });
    return result;
  };

  // Handle File Upload
  const handleFileChange = (e) => {
    setImage(e.target.files[0]);
  };

  // Update Menu
  const handleUpdate = async (e) => {
    e.preventDefault();
    const formData = new FormData();
    formData.append("title", title);
    formData.append("parent_id", parentId ? parseInt(parentId) : null);
    formData.append("position", parseInt(position));
    formData.append("is_category", isCategory);
    if (image) formData.append("image", image); // Append image only if a new one is selected

    try {
      await axios.put(`${baseurl}updateMenuWithImage/${id}`, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });

      Swal.fire({
        icon: "success",
        title: "Menu Updated!",
        text: "The menu has been updated successfully.",
      }).then(() => {
        navigate("/admin/menu-form");
      });
    } catch (error) {
      console.error("Error updating menu:", error);
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Something went wrong. Please try again later.",
      });
    }
  };

  return (
    <div className="App" style={{ display: "flex" }}>
      <AdminSidebar />

      <div className="content" style={{ flexGrow: 1, padding: "20px" }}>
        <AdminTopbar />
        <div className="container-fluid">
          <div className="d-flex justify-content-between align-items-center mb-2">
            <h4 className="text-start">Edit Menu</h4>
          </div>

          {loading ? (
            <div className="d-flex justify-content-center align-items-center">
              <div className="spinner-border text-primary" role="status">
                <span className="visually-hidden">Loading...</span>
              </div>
            </div>
          ) : (
            <div className="bg-white mb-3 p-2">
              <form onSubmit={handleUpdate} className="row g-3 text-start">
                {/* Title */}
                <div className="col-md-12">
                  <label className="form-label">Menu Title</label>
                  <input
                    type="text"
                    className="form-control"
                    value={title}
                    onChange={(e) => setTitle(e.target.value)}
                    required
                  />
                </div>

                {/* Parent Menu */}
                <div className="col-md-12">
                  <label className="form-label">Parent Menu</label>
                  <select
                    className="form-select"
                    value={parentId || ""}
                    onChange={(e) => setParentId(e.target.value)}
                  >
                    <option value="">Main Category</option>
                    {menus.map((menu) => (
                      <option key={menu.id} value={menu.id}>
                        {menu.fullTitle}
                      </option>
                    ))}
                  </select>
                </div>

                {/* Position */}
                <div className="col-md-4">
                  <label className="form-label">Position</label>
                  <input
                    type="number"
                    className="form-control"
                    value={position}
                    onChange={(e) => setPosition(e.target.value)}
                  />
                </div>

                {/* Is Category */}
                <div className="col-md-4 d-flex align-items-center">
                  <div className="form-check">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      checked={isCategory}
                      onChange={(e) => setIsCategory(e.target.checked)}
                    />
                    <label className="form-check-label ms-2">Is Category?</label>
                  </div>
                </div>

                {/* Current Image Preview */}
                {currentImage && (
                  <div className="col-md-12">
                    <label className="form-label">Current Image</label>
                    <div>
                      <img
                        src={`${imageUrl}menu/${currentImage}`}
                        alt="Current"
                        style={{ width: "150px", height: "auto", borderRadius: "5px", marginBottom: "10px" }}
                      />
                    </div>
                  </div>
                )}

                {/* Upload New Image */}
                <div className="col-md-12">
                  <label className="form-label">Upload New Image</label>
                  <input type="file" className="form-control" onChange={handleFileChange} accept="image/*" />
                </div>

                {/* Submit Button */}
                <div className="col-12 text-end">
                  <button type="submit" className="btn submitbtnn">
                    Update Menu
                  </button>
                </div>
              </form>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default EditMenu;
